const removeExistingIds = state => {
    const { id, rows, cells, ...restOfState } = state

    if ((rows || []).length > 0) {
        restOfState.rows = rows.map(removeExistingIds)
    } else if ((cells || []).length > 0) {
        restOfState.cells = cells.map(removeExistingIds)
    }

    return restOfState
}

export default removeExistingIds
